import { createBlock } from 'factories/block';
import { Block } from '@chameleoncreator/creator-app';
import { InteractionProps, reverse } from './interaction';
import { createLayout } from 'factories/layout';
import { createMediaBlock } from './media';
import { createContinueBtn } from './continueBtn';
import uuid from 'uuidv4';
import { getSId } from '../utils';

export type ImageInteractionProps = InteractionProps & {};

// const contentForColumn = props => (i: number) => {
//   // return [() => createBlock('Text'), () => createBlock('Image')][i];
//   return [() => createBlock('Text'), () => createMediaBlock(props)][i];
// };

// createMediaBlock({})

const createAssessmentIntroduction = (props?: {}) => {
  return createBlock(
    'AssessmentIntroduction',
    [
      // createBlock('Image'),
      createMediaBlock({}),
      createBlock('Text'),
    ],
    { props: {} }
  );
};

export const createAssessmentIntroductionInteractionBlock = (
  props: any,
  offset: number = 0
) => {
  return createBlock(
    'Interaction',
    [
      createAssessmentIntroduction(),

      createBlock('SingleColumnLayout', [
        createBlock(
          'Column',
          [
            // createBlock('ContinueButton', 'Continue' as any, {
            //   meta: { subType: 'continue' },
            // }),
            createContinueBtn(props.style),
          ],
          {
            props: {
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'center',
              flexWrap: 'wrap',
            },
            meta: {
              subType: 'ButtonBlock',
            },
          }
        ),
      ]),
    ],
    {
      props: {
        type: 'AssessmentIntroduction',
        name: props.name,
        sId: getSId('interaction', offset),
        style: props.style || {},
      },
      meta: {
        subType: 'AssessmentIntroduction',
        // layout: `${props.columnCount === 0 ? 'OneColumn' : 'TwoColumns'}${
        //   props.columnsReversed ? 'Reversed' : ''
        // }`,
      },
    }
  );
};

export const interactionConfig = {};
